import React from 'react';
import { IWizardItem } from '../WizardItem';
import Text from '../../../../BaseModule/Components/Text';
import styles from 'WizardText.module.scss';
import NoEscape from '../../../../../Utils/NoEscape';
import { WizardItemSubType } from '../../../Enums/WizardItemSubtype.enum';

interface Props {
	item: IWizardItem;
}

const WizardText: React.FC<Props> = ({ item }) => {
	switch (item.subtype) {
		case WizardItemSubType.HEADER:
			return <Text tx={item.title} className={styles.header} />;
		case WizardItemSubType.HTML:
			return <NoEscape children={item.title} />;
		case WizardItemSubType.NORMAL:
		default:
			return <Text tx={item.title} className={styles.normal} />;
	}
};

export default WizardText;
